import { Box } from "@mui/system";
import { IconButton, Modal, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import {
  hideLoaderForBatchApiCall,
  showLoaderForBatchApiCall,
} from "utils/helper";
import {
  GetAuditTrailListPayload,
  GetAuditTrailListSuccessPayload,
} from "store/studentProfileDetails/types";
import { IAuditTrailListData } from "utils/interfaces/student-profile-details";
import { useLocation } from "react-router";
import { closeIcon } from "assets/images";
import { DATE_TIME_DISPLAY_FORMAT } from "utils/constants/constant";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { getStudentDetailsSelector } from "store/student/selector";

interface IAuditTrailModalProps {
  handleAuditTrailModalClose: () => void;
  isAuditTrailModalOpen: boolean;
  getAuditTrailListRequest: (payload: GetAuditTrailListPayload) => {};
}

const AuditTrailModal: React.FC<IAuditTrailModalProps> = ({
  handleAuditTrailModalClose,
  isAuditTrailModalOpen,
  getAuditTrailListRequest,
}) => {
  const [auditTrailListData, setAuditTrailListData] = useState<
    IAuditTrailListData[]
  >([]);
  const studentDetails = useSelector(getStudentDetailsSelector);
  const location = useLocation<{
    studentId: number;
  }>();

  const onAuditTrailListSuccess = (
    response: GetAuditTrailListSuccessPayload
  ) => {
    setAuditTrailListData(response.auditTrailList);
    hideLoaderForBatchApiCall();
  };

  const getAuditTrailList = () => {
    if (getAuditTrailListRequest) {
      showLoaderForBatchApiCall();
      const values = {
        studentId: location.state.studentId,
      };
      const payload = {
        values,
        callback: onAuditTrailListSuccess,
      };
      getAuditTrailListRequest(payload);
    }
  };
  useEffect(() => {
    getAuditTrailList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal open={isAuditTrailModalOpen} onClose={handleAuditTrailModalClose}>
      <Box className="common-modal modal-600 timeline-modal">
        <Box className="modal-header">
          <Typography variant="h4">
            SLP Audit Trail -
            {` ${studentDetails?.firstName} ${studentDetails?.lastName}`}
          </Typography>
          <IconButton onClick={handleAuditTrailModalClose}>
            <img src={closeIcon} alt="close" />
          </IconButton>
        </Box>
        <Box className="modal-body">
          <div className="timeline">
            {auditTrailListData.map((item) => (
              <div className="timeline-item" key={item.id}>
                <span className="timeline-marker" />
                <div className="timeline-content">
                  <Typography variant="h5" className="timeline-title">
                    {item.action}
                    <span className="timeline-meta">
                      - By {item.actionByName}
                    </span>
                  </Typography>
                  <Typography variant="body2" className="timeline-text">
                    {item.details}
                  </Typography>
                  <Typography variant="body2" className="text-gray">
                    {dayjs(item.createdOn).format(DATE_TIME_DISPLAY_FORMAT)}
                  </Typography>
                </div>
              </div>
            ))}
          </div>
        </Box>
      </Box>
    </Modal>
  );
};
export default AuditTrailModal;
